import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class NotificationsService {

    constructor(private http: HttpClient) {
    }

    createNotification(message: string, createObjectId: string, category: string, type: string, usersList: any) {
        return this.http.post('/api/createNotification?message=' + message + '&createdObjectId=' + createObjectId + '&category=' + category + '&type=' + type, usersList);
    }

    getNewNotificationNumber() {
        return this.http.get('/api/getNewNotificationsNumber');
    }

    currentUserNotifications(page, size) {
        return this.http.get('/api/myNotifications?page=' + page + '&size=' + size);
    }

    markAllAsRead() {
        return this.http.put('/api/markAllNotificationsAsRead', {});
    }

    markOneAsRead(id) {
        return this.http.put('/api/markNotificationAsRead?notificationId=' + id, {});
    }

    clearAllNotification() {
        return this.http.delete('/api/deleteAllMyNotifications');
    }

    clearOneNotification(id) {
        return this.http.delete('/api/deleteMyNotification?notificationId=' + id);
    }
}
